export default __webpack_public_path__ + "static/media/jbl-speaker.ffaedc8c.png";